export const links = {
    product: $localize`:@@routes.produkt:produkt`,
    addons: $localize`:@@routes.addons:addons`,
    shop: $localize`:@@routes.shop:shop`,
    user_backend: $localize`:@@routes.user_backend:mein-konto`,
    blog: $localize`:@@routes.blog:blog`,
    about_us: $localize`:@@routes.about_us:ueber-uns`,
    press: $localize`:@@routes.press:presse`,
    funding: $localize`:@@routes.funding:foerdermittel`,
    terms: $localize`:@@routes.terms:assets/downloads/marktbox-agb.pdf`,
    contract: $localize`:@@routes.contract:assets/downloads/marktbox-mietvertrag.pdf`,
    privacy: $localize`:@@routes.privacy:datenschutz`,
    impressum: $localize`:@@routes.impressum:impressum`,
    guide: $localize`:@@routes.guide:ratgeber`,
    startguide: $localize`:@@routes.startguide:startguide`,
    customers: $localize`:@@routes.customers:kundenstimmen`,
    repair_shop: $localize`:@@routes.repair_shop:ersatzteile`,
}